"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAward = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new award.
 *
 * ## Usage
 *
 * ```ts
 * const award: Omit<Award, '_id'|'requirement'> = {
 *   name: "Masoveteran",
 *   description: "Award given for being a Masochist.ME member for 10 years.",
 *   img: "http://http.cat/404.jpg",
 *   category: "5f5affe76ba7865769",
 *   children: [],
 * 	 isStackable: false,
 * 	 isEnabled: true,
 *   isLegacy: false
 * };
 *
 * [TODO] Allow adding children here as well!!!
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createAward({ award });
 * ```
 *
 * @param params.award - Data of the new award. All fields of the type Award are required.
 */
const createAward = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { award } = params;
    const url = `${BASE_URL}/awards`;
    const awardResponse = yield axios_1.default.post(url, award, { validateStatus: () => true });
    const { status, data } = awardResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createAward = createAward;
